// Prod crash telemetry: catches uncaught errors + rejections and POSTs them to the server for triage.
// Dev/localhost is skipped (IS_DEV) so local hacking never spams the DO. Fire-and-forget: this must
// never throw or block the game loop, and only reports each unique message once per session (a broken
// frame loop can otherwise fire the same error thousands of times).

import { API } from './net';
import { IS_DEV } from './config';

const seen = new Set<string>();

function report(message: string, stack: string): void {
  if (IS_DEV || seen.has(message)) return;
  seen.add(message);
  try {
    fetch(API + '/api/telemetry', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        commit: __COMMIT__,
        message: message.slice(0, 500),
        stack: stack.slice(0, 4000),
        url: location.href,
        ua: navigator.userAgent,
      }),
    }).catch(() => {});
  } catch {
    // never let telemetry itself break the game
  }
}

export function installTelemetry(): void {
  if (IS_DEV) return;
  window.addEventListener('error', (e) => {
    report(e.message || 'unknown error', e.error && e.error.stack ? String(e.error.stack) : '');
  });
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason;
    const message = reason && reason.message ? String(reason.message) : String(reason);
    const stack = reason && reason.stack ? String(reason.stack) : '';
    report(message, stack);
  });
}
